import { Controller } from "@hotwired/stimulus";

// Hides the "also available in ..." bar and remembers it for a year.
export default class extends Controller {
  dismiss() {
    document.cookie = "pause.locale_hint=dismissed; path=/; max-age=31536000; samesite=lax";
    this.element.remove();
  }
}
